
export const SocialBar = ({items}) => <div className="social-bar">{items&&items.map(({link, type}, i)=><div key={`social_${i}`}><a href={link} target="_blank"><i className={"fa fa-"+type} aria-hidden="true"></i></a></div>)}
<div className="h-text">FOLLOW US</div>
</div>